import { render, staticRenderFns } from "./AlbumView.vue?vue&type=template&id=11891f23&scoped=true&"
import script from "./AlbumView.vue?vue&type=script&lang=ts&"
export * from "./AlbumView.vue?vue&type=script&lang=ts&"
import style0 from "./AlbumView.vue?vue&type=style&index=0&id=11891f23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11891f23",
  null
  
)

export default component.exports